/*
 * magic-nav (魔法导航)
 * Copyright (C) 2026 魔法代码
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 *
 * SPDX-License-Identifier: GPL-3.0-or-later
 */

import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import { getToken } from '../auth/api/auth'

// 路由基础路径
const basePath = import.meta.env.VITE_BASE_PATH || '/'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'home',
    component: () => import('../nav/NavApp.vue'),
    meta: { title: '魔法导航' }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../auth/views/LoginPage.vue'),
    meta: { title: '登录' }
  },
  {
    path: '/admin',
    name: 'admin',
    component: () => import('../admin/views/AdminPage.vue'),
    meta: { title: '管理后台', requiresAuth: true }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(basePath),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

// 全局前置守卫
router.beforeEach((to) => {
  // 需要登录但未携带 Token -> 跳转登录页
  if (to.meta.requiresAuth && !getToken()) {
    return { name: 'login', query: { redirect: to.fullPath } }
  }
  // 已登录访问登录页 -> 直接进入后台
  if (to.name === 'login' && getToken()) {
    return { name: 'admin' }
  }
  return true
})

// 全局后置守卫：动态设置页面标题
router.afterEach((to) => {
  const title = to.meta.title as string | undefined
  document.title = title || '魔法导航'
})

export default router
